module.exports = __webpack_public_path__ + "static/img/fcBg.11a5c10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fcBg.png
// module id = 6yiM
// module chunks = 101